// @flow

import ReduceStore from 'PMT/flux/ReduceStore';
import _ from 'lodash';

import { ArrayUtils } from 'PMT/utils';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import OrdersList from 'PMT/entities/order/OrdersList';
import Order from 'PMT/entities/order/Order';

function updateOrder(state, order: Order) {

  if (!_.isNull(state.ordersList)) {
    state.ordersList.updateOrder(order);
  }

  if (!_.isNull(state.dueDateOrdersList)) {
    state.dueDateOrdersList.updateOrder(order);
  }

  return state;
}

class OrdersListStore extends ReduceStore {

  getInitialState() {
    return {
      apiError: null, // ApiError
      ordersList: null,  // OrdersList
      dueDateOrdersList: null, // OrdersList
      updatedOrder: null, // Order
      lastUpdateTime: null, // number
    }
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      ordersList: new OrdersList(),
      dueDateOrdersList: new OrdersList(),
      updatedOrder: new Order(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getOrdersList(): OrdersList {
    return this._state.ordersList;
  }

  getDueDateOrdersList(): OrdersList {
    return this._state.dueDateOrdersList;
  }

  getLastUpdateTime(): number {
    return this._state.lastUpdateTime;
  }

  getUpdatedOrder(): Order {
    return this._state.updatedOrder;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_SUCCESS:
      case ActionTypes.ON_GOING_ORDERS_LISTRESPONSE_SUCCESS:
        const newOrdersList: OrdersList = action.ordersList;

        nextState.lastUpdateTime = action.toTime;

        if (!_.isNull(nextState.ordersList)) {
          let haveNewOrders = false;

          // update orders
          _.each(newOrdersList.orders, (order: Order) => {
            const exists = ArrayUtils.exists(nextState.ordersList.orders, { id: order.id });
            if (!exists) {
              if (!order.isCanceled()) {
                // a new order exists, we set it, the front will notify the user.
                haveNewOrders = true;
              }
              nextState.ordersList.addOrder(order);
            } else {
              nextState.ordersList.updateOrder(order);
            }
          });
          nextState.ordersList.haveNewOrders = haveNewOrders;
        } else {
          nextState.ordersList = newOrdersList;
        }

        nextState.apiError = null;

        this.emitEvent(Events.ON_RETRIEVE_ORDERS_LIST_SUCCESS);
        return nextState;

      case ActionTypes.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_FAILURE:
      case ActionTypes.ON_GOING_ORDERS_LISTRESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_RETRIEVE_ORDERS_LIST_FAILURE);
        return nextState;

      case ActionTypes.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_SUCCESS:
        // if (_.isNull(nextState.dueDateOrdersList)) {
        nextState.dueDateOrdersList = action.ordersList;
        // } else {
          // _.each(action.ordersList.orders, (order:Order) => {
            // nextState.dueDateOrdersList.updateOrder(order);
          // });
        // }
        this.emitEvent(Events.ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_SUCCESS);
        return nextState;

      case ActionTypes.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_FAILURE);
        return nextState;

      case ActionTypes.UPDATE_ORDER_RESPONSE_SUCCESS:
        updateOrder(nextState, action.order);
        nextState.updatedOrder = action.order;
        this.emitEvent(Events.UPDATE_ORDER_SUCCESS);
        return nextState;

      case ActionTypes.UPDATE_ORDER_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.UPDATE_ORDER_FAILURE);
        return nextState;

      default:
        return nextState;
    }
  }
}

export default new OrdersListStore();



// WEBPACK FOOTER //
// ./scripts/stores/OrdersListStore.js